<template>
  <svg class="chevron-left" xmlns="http://www.w3.org/2000/svg" width="6.1" height="9.4" viewBox="0 0 6.1 9.4">
  <path id="Path_36" data-name="Path 36" d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z" transform="translate(-2 11.4) rotate(-90)" fill="#2699fb"/>
</svg>

</template>

<script>
  export default {
    name: 'ChevronLeftIcon'
  }
</script>

<style>
  .chevron-left {
    transform: rotate(180deg);
  }
</style>